import { useState } from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import { ArrowRight } from "lucide-react";

import { Dialog, DialogContent } from "@/components/Dialog";
import { Button } from "@/components/Button";
import { AnalyticsStep } from "./steps/AnalyticsStep";

// Second chance after skipping the SEO setup: the same Google step the stepper has.
export function GoogleConnectOfferModal({ open, client, onFinish }) {
  const [connected, setConnected] = useState(false);

  return (
    <Dialog open={open} onOpenChange={() => {}} disableBackdropClose maxWidth="md" fullWidth>
      <DialogContent sx={{ px: { xs: 2.5, sm: 4 }, pt: 4, pb: 3 }}>
        <AnalyticsStep clientId={client.id} client={client} onConnected={() => setConnected(true)} />
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: { xs: "stretch", sm: "flex-end" }, mt: 3 }}>
          {connected ? (
            <Button onClick={onFinish}>
              Continuar <ArrowRight size={16} />
            </Button>
          ) : (
            <Button variant="outline" onClick={onFinish}>
              Omitir por ahora
            </Button>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
}

GoogleConnectOfferModal.propTypes = {
  open: PropTypes.bool.isRequired,
  client: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    name: PropTypes.string,
  }).isRequired,
  onFinish: PropTypes.func.isRequired,
};

export default GoogleConnectOfferModal;
